import { useCallback } from 'react';
import { useOpenLayers } from '../react-ol';
export var CLEAR_FEATURES_KEY = 'clearFeatures';

var clearLayerFeatures = layer => {
  var _layer$getSource;

  (_layer$getSource = layer.getSource()) === null || _layer$getSource === void 0 ? void 0 : _layer$getSource.clear(); // set custom prop clearFeatures so we can later listen
  // to propertychange event to check if features were cleared

  layer.set(CLEAR_FEATURES_KEY, true);
};
/**
 * Can Clear single layer or multiple layer features
 *
 * Takes layer id or reference
 *
 * Works on `VectorLayer` type only
 *
 * Must be used within map context
 *
 */


var useClearFeatures = layerId => {
  var {
    map
  } = useOpenLayers();
  return useCallback(() => {
    if (!map) return;
    var layers = map.getLayers().getArray();

    if (Array.isArray(layerId)) {
      var targetLayers = layers.filter(l => layerId.includes(l.get('reference')) || layerId.includes(l.get('id')));
      targetLayers.length && targetLayers.forEach(layer => {
        clearLayerFeatures(layer);
      });
    } else {
      var targetLayer = layers.find(l => l.get('id') === layerId || l.get('reference') === layerId);

      if (targetLayer) {
        clearLayerFeatures(targetLayer);
      }
    }
  }, [layerId, map]);
};

export default useClearFeatures;